"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerRootModules = exports.registerRootProviders = exports.createNamespaceHelpers = exports.inject = exports.createModuleContainer = exports.createRootContainer = exports.getRoot = void 0;
var container_1 = require("./container");
var constant_1 = require("./constant");
var logger_1 = require("./logger");
function getRoot() {
  return constant_1._global[constant_1.key];
}
exports.getRoot = getRoot;
function createRootContainer(props) {
  if (getRoot()) {
    logger_1.log('根容器已存在, 跳过创建，应用providers和modules。');
    registerRootProviders(props.providers);
    registerRootModules(props.modules);
  } else {
    var container = new container_1.Container(__assign(__assign({}, props), {
      namespace: "root"
    }));
    constant_1._global[constant_1.key] = container;
  }
}
exports.createRootContainer = createRootContainer;
function createModuleContainer(props) {
  var root = getRoot();
  var container = new container_1.Container(props);
  if (!root) {
    console.log('根容器不存在，自动创建根容器。');
    createRootContainer({
      providers: [],
      modules: [container]
    });
    root = getRoot();
  }
  root.registerModule(container, props.namespace);
  return container;
}
exports.createModuleContainer = createModuleContainer;
function _inject(name, scope) {
  var rootContainer = constant_1._global[constant_1.key];
  if (!rootContainer) {
    throw new Error("root IOC container does not exists. ");
  }
  var targetContainer = scope && scope !== "root" ? rootContainer.getModule(scope) : rootContainer;
  var instance = targetContainer === null || targetContainer === void 0 ? void 0 : targetContainer.getInstance(name);
  if (targetContainer.depsMap.get(name)) {
    targetContainer === null || targetContainer === void 0 ? void 0 : targetContainer.getInstance(targetContainer.depsMap.get(name));
    targetContainer === null || targetContainer === void 0 ? void 0 : targetContainer.getInstanceMap().delete(name);
  }
  instance = targetContainer === null || targetContainer === void 0 ? void 0 : targetContainer.getInstance(name);
  return instance;
}
exports.inject = _inject;
function createNamespaceHelpers(namespace) {
  return {
    inject: function inject(name) {
      return _inject(name, namespace);
    }
  };
}
exports.createNamespaceHelpers = createNamespaceHelpers;
function registerRootProviders(providers) {
  var root = getRoot();
  if (!root) {
    throw new Error('Root IOC Container does not exist.');
  }
  root.registerProviders(providers);
}
exports.registerRootProviders = registerRootProviders;
function registerRootModules(modules) {
  if (modules === void 0) {
    modules = [];
  }
  var root = getRoot();
  if (!root) {
    throw new Error('Root IOC Container does not exist.');
  }
  modules.forEach(function (m) {
    return root.registerModule(m, m.namespace);
  });
}
exports.registerRootModules = registerRootModules;